import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ProduccionHuevosTable.css";
import {
  faTrash,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import DetallesProduccion from "../DetallesProduccion/DetallesProduccion";
import { useShoppingContext } from "../../../../context/ShoppingContext";

const ProduccionHuevosTable = () => {
  const {
    produccionHuevos,
    getAveNombre,
    renderDateTitle,
    handleDeleteProduccionHuevos,
    selectedFiltroDate,
    endDate,
    startDate,
    selectedLote,
    selectedAve,
    fetchProduccionHuevos,
  } = useShoppingContext();

  useEffect(() => {
    fetchProduccionHuevos(); // Cargar los datos de producción
  }, [fetchProduccionHuevos]);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProduccion, setSelectedProduccion] = useState(null);
  const itemsPerPage = 3;
  const pagesToShow = 5;

  // Aplicar los filtros y ordenar los datos
  const applyFilters = () => {
    const sortedProduccionHuevos = [...produccionHuevos].sort(
      (a, b) => new Date(b.fecha) - new Date(a.fecha)
    );

    return sortedProduccionHuevos.filter((produccion) => {
      const isDateMatch = selectedFiltroDate
        ? new Date(produccion.fecha).setHours(0, 0, 0, 0) ===
          selectedFiltroDate.setHours(0, 0, 0, 0)
        : true;

      const isLoteMatch = selectedLote
        ? produccion.id_ave === parseInt(selectedLote)
        : true;

      const isRangeMatch =
        startDate && endDate
          ? new Date(produccion.fecha) >= startDate &&
            new Date(produccion.fecha) <= endDate
          : true;

      const isAveMatch = selectedAve
        ? produccion.id_ave === selectedAve.id
        : true;

      return isDateMatch && isLoteMatch && isRangeMatch && isAveMatch;
    });
  };

  const filteredProduccionHuevos = applyFilters();

  const totalPages = Math.ceil(filteredProduccionHuevos.length / itemsPerPage);

  const paginatedData = filteredProduccionHuevos.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [startPage, setStartPage] = useState(1);

  const handleNextPageGroup = () => {
    if (startPage + pagesToShow <= totalPages) {
      setStartPage(startPage + pagesToShow);
      setCurrentPage(startPage + pagesToShow);
    }
  };

  const handlePrevPageGroup = () => {
    if (startPage - pagesToShow >= 1) {
      setStartPage(startPage - pagesToShow);
      setCurrentPage(startPage - pagesToShow);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPagination = () => {
    const pageNumbers = [];
    const endPage = Math.min(startPage + pagesToShow - 1, totalPages);
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <span
          key={i}
          className={`pagination-item ${currentPage === i ? "active" : ""}`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </span>
      );
    }

    return (
      <div className="pagination-container">
        {startPage > 1 && (
          <button
            className="pagination-arrow"
            onClick={handlePrevPageGroup}
          >
            {"<"}
          </button>
        )}
        {pageNumbers}
        {startPage + pagesToShow - 1 < totalPages && (
          <button
            className="pagination-arrow"
            onClick={handleNextPageGroup}
          >
            {">"}
          </button>
        )}
      </div>
    );
  };

  return (
    <div>
      <table className="produccion-huevos-table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Total (unidades)</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((produccion) => (
            <tr
              key={produccion.id}
              onClick={() => setSelectedProduccion(produccion)}
              className="cursor-pointer"
            >
              <td>
                <div>
                  <strong>{getAveNombre(produccion.id_ave)}</strong>
                  <br />
                  <small>{renderDateTitle(produccion.fecha)}</small>
                </div>
              </td>
              <td>{produccion.total}</td>
              <td className="flex">
                <button
                  className="btn btn-warning"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event propagation to tr
                    console.log("Edit:", produccion.id);
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button
                  className="btn btn-danger"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event propagation to tr
                    handleDeleteProduccionHuevos(produccion.id);
                  }}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Renderizar la paginación */}
      <div className="flex">
        {renderPagination()}
      </div>

      {/* Mostrar detalles de la producción seleccionada */}
      {selectedProduccion && (
        <div className="detalles-produccion">
          <DetallesProduccion selectedProduccion={selectedProduccion} />
        </div>
      )}
    </div>
  );
};

export default ProduccionHuevosTable;
